module.exports = __webpack_public_path__ + "img/2025-03-27-01-02.9daef67a.png";